import { useTranslations } from '@vocab/react';
import { Box, Pagination, Stack } from 'braid-design-system';
import { useNavigate } from 'react-router-dom';

import GroupThreadsView from 'src/components/organisms/CommunityGroups/GroupThreadsView';
import { FEATURED_THREADS_PAGE_SIZE } from 'src/core/domain/constants';
import { getPagePaths } from 'src/core/domain/pages';
import { useConfig } from 'src/provider/config';
import { useGroupThreads } from 'src/provider/groupThreads';
import { usePage } from 'src/provider/page';
import { fetchCategoryThreads } from 'src/services/threadsService';

import translations from './.vocab';

export default () => {
  const { t } = useTranslations(translations);
  const {
    pageDispatch,
    pageState: { pageNumber, groupId, pageSlug, categoryId },
  } = usePage();

  const {
    groupThreadsDispatch,
    groupThreadsState: { groupThreads },
  } = useGroupThreads();
  const { language, ...restConfigProps } = useConfig();
  const navigate = useNavigate();
  const {
    category: category,
    total: total,
    totalPage: totalPage,
    pageInfo: pageInfo,
  } = groupThreads ?? {};

  const getLinkProps = ({ page }: { page: number }) => ({
    href: `${
      getPagePaths({
        language,
        pathParams: { groupSlug: `${pageSlug}-${groupId}` },
        queryParams: { page: page.toString() },
      }).communityGroupsDetails
    }`,
    onClick: async (e: any) => {
      e.preventDefault();
      navigate(`?page=${page}`, { replace: true });

      pageDispatch({ type: 'SET_PAGE_NUMBER', payload: { pageNumber: page } });
      const { threads } = await fetchCategoryThreads({
        categoryId,
        cursor: (page - 1) * FEATURED_THREADS_PAGE_SIZE,
        config: { language, ...restConfigProps },
      });
      groupThreadsDispatch({
        type: 'UPDATE_GROUP_THREADS',
        payload: { threads, category, total, totalPage, pageInfo },
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  });

  return (
    <Stack
      space={{
        mobile: 'xsmall',
        tablet: 'xsmall',
        desktop: 'xsmall',
      }}
    >
      <GroupThreadsView />
      {groupThreads && groupThreads.totalPage > 1 ? (
        <Box paddingY="xxlarge">
          <Pagination
            page={pageNumber || 1}
            total={groupThreads?.totalPage || 1}
            linkProps={getLinkProps}
            label={groupThreads?.category.name}
            nextLabel={t('next')}
            previousLabel={t('previous')}
          />
        </Box>
      ) : null}
    </Stack>
  );
};
